<div class="title-group">
	<div class="title-div">
		<img class="title-div-img" [src]="SelectedImageLibraryItem.ImageLibraryData_Thumb" />
	</div>

	<div class="title-div" style="margin-top: 5px">
		<label>{{ SelectedImageLibraryItem.ImageLibraryItemName }}</label>
	</div>
</div>

<div class="copy-group">
	<!--			   -->
	<!-- Copy As Name  -->
	<!-- 			   -->
	<div class="copy-group-item">
		<div class="copy-group-item-div1">
			<label>New Image Name</label>
		</div>

		<div style="width: 300px">
			<input type="text" class="form-control" name="CopyImage" [(ngModel)]="NewImageLibraryItemName" />
		</div>
	</div>

	<!-- 		               -->
	<!-- Image Group Selector  -->
	<!-- 				       -->
	<div class="copy-group-item">
		<div class="copy-group-item-div1">
			<label>To Image Group</label>
		</div>

		<div>
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<select
				class="form-control"
				name="ImageGroupSelector"
				style="font-size: smaller"
				[(ngModel)]="SelectedImageGroup"
				(ngModelChange)="onImageGroupChange($event)"
			>
				<option *ngFor="let r of lstImageGroup" [ngValue]="r">
					{{ r.ImageLibraryGroupDesc }}
				</option>
			</select>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="copy-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onCopy()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
